<ion-content>
  <div class="conversation-page-wrapper">
    <div class="activ-users-list">
      <a
        *ngFor="let user of usersList"
        (click)="goTo('messagerie', user)"
      >
        <img
          *ngIf="user.other.image && user.other.image.length"
          [src]="user.other.image"
          alt="user active"
          srcset=""
        />
        <img
          *ngIf="!(user.other.image && user.other.image.length)"
          src="../../../../assets/icon/icone-profile/profile_img.svg"
          alt="user active"
          srcset=""
        />
      </a>
    </div>
    <div class="search-container">
      <input
        type="text"
        (input)="handleSearch($event)"
        [placeholder]="'CONVERSATION_PAGE.SEARCH_CONV' | translate"
      />
    </div>
    <h2 *ngIf="usersList.length" class="messages-title">
      {{ "CONVERSATION_PAGE.MESSAGES" | translate }}
    </h2>
    <div *ngIf="!usersList.length" class="no-messages">
      Pas de messages pour le mot clé {{ searchQuery }}
    </div>

    <a
      *ngFor="let user of usersList"
      class="conv-desc"
      (click)="goTo('messagerie', user)"
    >
      <img
        [src]="user.other.image"
        *ngIf="user.other.image && user.other.image.length"
        alt="user image"
      />
      <img
        src="../../../../assets/icon/icone-profile/profile_img.svg"
        *ngIf="!(user.other.image && user.other.image.length)"
        alt="user image"
      />
      <div class="desc-details">
        <h2>{{ user.other.first_name }} {{ user.other.last_name }}</h2>
        <p>
          <b *ngIf="(user.is_read === 0) && (user.reciever.id != userId)">{{ user.type === "text" ? user.message : user.type }}</b>
          <span *ngIf="((user.is_read === 1) || (user.reciever.id == userId))"> {{ user.type === "text" ? user.message : user.type }}</span>
        </p>
      </div>
      <div class="conv-info">
        <div *ngIf="((user.recieverid != userId) &&( user.is_read  === 0) && (user.unread_count >0))" class="unread-notif">+{{user.unread_count}}</div>
        <p class="last-seen">{{ formatDate(user.updated_at) }}</p>
      </div>
    </a>
  </div>
</ion-content>
